import { render, staticRenderFns } from "./Scoping.vue?vue&type=template&id=2535b83f"
import script from "./Scoping.vue?vue&type=script&lang=js"
export * from "./Scoping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports